import './UploadFile.scss';
import Component from './UploadFile.js';
export default Component;
